module.exports = __webpack_public_path__ + "static/media/songoroo-2@2x.2491ebae.png";